export default "__VITE_ASSET__CEiptvbV__"